"use strict";
export const NATIVE_CHAIN_ID = "NATIVE";
export const UNKNOWN_TOKEN_SYMBOL = "UNKNOWN";
export const USDC_ADDRESSES = [
  // Base
  "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913"
];
export function isUSDCToken(address) {
  if (!address) return false;
  return USDC_ADDRESSES.includes(address.toLowerCase());
}
